module.exports = "/dist/app/images/location@2x.png?a0e2707aea165af95dcd8eb9a26fe3cd";